module.exports = __webpack_public_path__ + "media/svg/ae-a9f6b270.svg";